import './style.scss';
import template from './fileUploadSimple.html';
import FileUploadCtrl from '../fileUploadCtrl';

export default {
  template,
  bindings: {
    onCompleteAll: '&', // not required | {expression} // contains $response
    multiple: '<', // not required | {boolean} will tell if you allow multiple upload
    extensions: '<', // not required | {array} of extensions you wish to accept
    url: '<', // not required | {string}
    familyId: '<', // not required | {string}
    documentId: '<', // not required | {string}
    uploadType: '<', // not required | {string}
    autoUpload: '<', // not required | {boolean}
    height: '<', // not required | {string}
    width: '<', // not required | {string}
    invalidFileInfo: '=', // not required | {object} eg. {title: 'Bad file type', description: 'Should accept PNG'}
    noUrlParams: '<', // not required | {boolean}
    type: '<', // not required | {int}
    isPresignedUrl: '<?',
  },
  controller: FileUploadCtrl,
  controllerAs: 'vm',
};
